import { createAction } from '@reduxjs/toolkit';

export const setSessionId = createAction('SET_SESSION_ID', (sessionId: string) => {
  return {
    payload: sessionId,
  };
});
